module.exports = __webpack_public_path__ + "static/media/dot.a0af0e0f.svg";